§<template>

    <ui-view class="view-water-insights">

        <ui-heading title="Water inzichten" icon="entypo-water"/>

        <ui-panel v-if="waterInsights">

            <div class="insights-filters">
                <pm-available-date-picker
                    :date="selectedDate"
                    :availableDates="waterInsightsDates"
                    @update:date="selectedDate = $event"
                />
                <ui-dropdown class="series-picker" :options="waterInsightsSeriesOptions" v-model="filter.parcelSeriesId"/>
            </div>

            <div class="insights-data" v-if="selectedDate">
                <img :src="waterInsightsUrlByDate.get(selectedDate)" :alt="`Water inzichten - ${selectedDate}`"/>
            </div>

        </ui-panel>
    </ui-view>

</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';

import createQuery from 'js-core/js/apollo/queries/createQuery';

import WaterInsightsSeries from 'common/enums/WaterInsightsSeries';
import waterInsightsSeriesTitle from 'common/filters/waterInsightsSeriesTitle';

import WaterInsightsImagesQuery from 'gql/queries/WaterInsights/WaterInsightsImages.gql';

import AvailableDatePicker from 'app/components/ui/AvailableDatePicker.vue';

@Component({
    name: 'WaterInsights',
    components: {
        'pm-available-date-picker': AvailableDatePicker
    },
    apollo: {

        waterInsights: createQuery(WaterInsightsImagesQuery,{

            variables(){

                return {
                    parcelLocationId: this.filter.parcelLocationId,
                    parcelSeriesId: this.filter.parcelSeriesId
                };
            },
            response(data) {

                if(!data.length){

                    this.selectedDate = null;
                    return;
                }

                this.selectedDate = data.reduce((latest, current) =>
                    new Date(latest.date) > new Date(current.date) ? latest : current
                ).date;
            }
        })
    }
})
export default class Users extends Vue
{

    loading = 0;

    filter = this.$persist('filter', {
        parcelSeriesId: WaterInsightsSeries.S3CHL,
        parcelLocationId: null
    });

    waterInsights = null;

    selectedDate = null;

    breadcrumb(){

        return 'Water inzichten';
    }

    get waterInsightsUrlByDate() {

        let waterInsightsUrlByDate = new Map();

        if(!this.waterInsights) {
            return waterInsightsUrlByDate;
        }

        for(let waterInsight of this.waterInsights) {
            waterInsightsUrlByDate.set(waterInsight.date, waterInsight.url);
        }

        return waterInsightsUrlByDate;
    }

    get waterInsightsSeriesOptions() {

        return Object.keys(WaterInsightsSeries).map(key => ({
            value: WaterInsightsSeries[key],
            label: waterInsightsSeriesTitle(WaterInsightsSeries[key])
        }));
    }

    get waterInsightsDates() {

        if(!this.waterInsights) {
            return [];
        }

        return this.waterInsights.map(waterInsight => waterInsight.date);
    }
}

</script>